const getDependenciesById = state => state.data.dependencies.byId;

const doesDependencyReferenceItems = (d, itemIds) => {
  return itemIds.indexOf(d.subject) >= 0 || itemIds.indexOf(d.object) >= 0;
};

const doesDependencyExist = (state, subjectId, objectId) => {
  const dependencies = getDependenciesById(state);
  return dependencies.find(dep => dep.subject === subjectId && dep.object === objectId) !== undefined;
};

const getDependenciesToBeDeletedWithItems = (globalState, itemIds) => {
  return getDependenciesById(globalState)
    .filter(c => doesDependencyReferenceItems(c, itemIds))
    .map(c => c.id)
    .toList();
};

const getDependenciesBetweenItems = (state, itemIds) =>
  getDependenciesById(state)
    .filter(d => itemIds.includes(d.subject) && itemIds.includes(d.object))
    .toList();

const getDependencyIdsBetweenItems = (state, itemIds) => getDependenciesBetweenItems(state, itemIds).map(d => d.id);

export default {
  getDependenciesById,
  getDependenciesToBeDeletedWithItems,
  doesDependencyExist,
  getDependenciesBetweenItems,
  getDependencyIdsBetweenItems
};
